import { IDefineCommand, IQuery } from 'core-ts-types';
angular
  .module('capability-ng-academic-planner')
  .service('setupUserCommand', ($http: ng.IHttpService, log: any, defineCommand: IDefineCommand) =>
    defineCommand('setupUserCommand', (deferred: ng.IDeferred<IQuery[]>) =>
      $http
        .post('core/setupusers', {})
        .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => deferred.resolve(data))
        .catch((e: string) => {
          log.issue('unable to setup the user');
          deferred.reject(e);
        })
    )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/setup_user_command.ts